import { Injectable } from '@angular/core';

declare let gtag:Function; // Declare gtag as a function

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  constructor() { }

  // public eventEmitter(eventCategory: string, eventAction: string,
  //    eventLabel: string = null, eventValue: number = null ){
  //     gtag('send', 'event', {
  //       eventCategory: eventCategory,
  //       eventLabel: eventLabel,
  //       eventAction: eventAction,
  //       eventValue: eventValue
  //     });
  // }

  public eventEmitter( 
    eventName: string, 
    eventCategory: string, 
    eventAction: string, 
    eventLabel: string = null,  
    eventValue: number = null ){ 
      gtag('event', eventName, { 
        eventCategory: eventCategory, 
        eventLabel: eventLabel, 
        eventAction: eventAction, 
        eventValue: eventValue
      })
    }

}
